import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white/30 backdrop-blur-md text-[#5c2f2f] border-t border-[#f2cccc] shadow-inner mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center gap-2 text-sm font-medium">
        <p>&copy; {new Date().getFullYear()} 10E Beauty. All rights reserved.</p>

        <div className="flex gap-4">
          <Link to="/privacy-policy" className="hover:underline hover:text-[#a25d5d] transition">Privacy Policy</Link>
          <Link to="/terms" className="hover:underline hover:text-[#a25d5d] transition">Terms of Service</Link>
          <Link to="/contact-us" className="hover:underline hover:text-[#a25d5d] transition">Contact Us</Link>
          <Link to="/about-us" className="hover:underline hover:text-[#a25d5d] transition">About Us</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
